import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, StyledError, Message } from './Error.style';
import PropTypes from 'prop-types';

/**
 * Error page
 */
const Error = ({ message }) => {

    const { t } = useTranslation()

    return (
        <StyledError>
            <Heading>{ t('error.heading') }</Heading>
            
            <Message>
                { message }
            </Message>

        </StyledError>
    )
}

Error.propTypes = {
    message: PropTypes.string.isRequired
}
export default Error;